export default {
  badge: 'Em configuração',
  title: 'Conclua a configuração do seu restaurante',
  description: 'Faltam alguns passos para o seu restaurante ficar ativo.',
  count: '{{done}} de {{total}} passos concluídos',
  cta: 'Continuar configuração',
  done: {
    badge: 'Tudo pronto',
    title: 'Está tudo pronto',
    description: '{{partner}} irá colocar o seu restaurante online.',
    fallback_partner: 'O seu fornecedor',
  },
};
